import { useState } from 'react';

import classNames from 'classnames';
import { DutyHourType } from 'generated';
import { useSelector } from 'hooks';
import { uniqBy } from 'lodash';
import styled from 'styled-components';

import {
  OpenDuty as OpenDutyType,
  PlannedDuty as PlannedDutyType
} from './types';

import { getPeriodsInterval } from 'components/shared/roster/RosterViewByDuty/utils';
import { getHoursMinutes } from 'utils/date';

import DutyIcons from './DutyIcons';
import OpenRequestDuty from './OpenRequestDuty/OpenRequestDuty';
import PlannedDuty from './PlannedDuty/PlannedDuty';

type Props = {
  duty: PlannedDutyType | OpenDutyType;
  portal: string;
  isGroupedByPlanunit: boolean;
  isGroupedByFunction: boolean;
};

const DutyEntry = ({
  duty: _duty,
  portal,
  isGroupedByPlanunit,
  isGroupedByFunction,
  className
}: Props & { className: string }) => {
  const [duty, updateDuty] = useState(_duty);
  const { showDutyHourTypes } = useSelector((state) => state.preferences);
  const { isOpen, costCenter, periods, dutyCode } = duty;
  const periodsInterval = getPeriodsInterval(periods);
  const dutyContent = (
    <>
      {!dutyCode && periods && (
        <div className="periods">
          <div className="period">
            {getHoursMinutes(periodsInterval.startTime)} -{' '}
            {getHoursMinutes(periodsInterval.endTime)}
          </div>
          {showDutyHourTypes &&
            ((dhts) =>
              dhts.length > 0 ? (
                <div className="dhts">
                  {dhts.map(({ code, dutyHourTypeId }) => (
                    <div key={dutyHourTypeId} className="dht-code">
                      {code}
                    </div>
                  ))}
                </div>
              ) : (
                ''
              ))(
              uniqBy(
                periods
                  .filter(
                    ({ dutyHourType }) => dutyHourType && dutyHourType.code
                  )
                  .map(({ dutyHourType }) => dutyHourType as DutyHourType),
                'code'
              ).filter((dutyHourType, i, arr) =>
                arr.length === 1
                  ? !dutyHourType?.dutyHourTypeFlags?.includes('DEFAULT')
                  : true
              )
            )}
        </div>
      )}
      <DutyIcons {...duty} />
      {!isGroupedByPlanunit && costCenter && <div>{costCenter.name}</div>}
    </>
  );
  if (!isOpen) {
    return (
      <PlannedDuty duty={duty} portal={portal} className={className}>
        {dutyContent}
      </PlannedDuty>
    );
  }

  if (isOpen) {
    return (
      <OpenRequestDuty
        duty={duty}
        updateDuty={updateDuty}
        isGroupedByFunction={isGroupedByFunction}
        portal={portal}
        className={className}
      >
        {dutyContent}
      </OpenRequestDuty>
    );
  }

  return <></>;
};

const DutyEntryStyles = styled.div`
  .duty-header {
    font-family: 'SourceSansPro-Bold', Arial, 'sans-serif';
  }
`;

export default function StyleDutyEntry(props: Props) {
  return (
    <DutyEntryStyles>
      <DutyEntry
        {...props}
        className={classNames({ 'is-faded': !props.duty.isPublished })}
      />
    </DutyEntryStyles>
  );
}
